module.exports = {
	"copy": {
		"header": " Save This Item in a Folder",
		"text": "Click the folder icon to save items into organized folders."
	}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Favorites/PdpFolderItemCallout.json
// module id = 2579
// module chunks = 4